import ajaxService from './ajaxService';

export default {
  // 訂單列表查詢
  getOrders(body, headers) {
    return ajaxService.post('/sct/post/api/v1/orderlistquery', body, headers);
  },
  // 取得特定訂單資訊
  getOrderwithERPOrderID(body, headers) {
    return ajaxService.post('/sct/post/api/v1/orderdataquery/erporder-id', body, headers);
  },
  // 取得訂單數量
  getOrderCount(body, headers) {
    return ajaxService.post('/sct/post/api/v1/order/count', body, headers);
  },
  // 取得會員的最愛兌禮商品資料
  getMemberFavoriteRedeemItems(headers) {
    return ajaxService.post('/sct/get/api/v1/redeem/favorite', {}, headers);
  },
  // 更新會員的最愛兌禮商品資料
  updateMemberFavoriteRedeemItems(body, headers) {
    return ajaxService.post('/sct/post/api/v1/redeem/favorite', body, headers);
  },
  // 更新會員的購物車資料
  updateRedeemItemsCart(body, headers) {
    return ajaxService.post('/sct/post/api/v1/redeem/cart', body, headers);
  },
  // 取得會員的購物車資料
  getRedeemItemsCart(headers) {
    return ajaxService.post('/sct/get/api/v1/redeem/cart', {}, headers);
  },
  // 取得會員的兌禮商品兌換時間
  getRedeemTime(headers) {
    return ajaxService.post('/sct/get/api/v1/redeem/orderItemSaleTimes', {}, headers);
  },
  // 新增兌禮訂單
  createRedeemOrder(body, headers) {
    return ajaxService.post('/sct/post/api/v1/redeem/order', body, headers);
  },
  // 取得兌禮訂單
  getRedeemOrders(body, headers) {
    return ajaxService.post('/sct/post/api/v1/redeem/ordersInfo', body, headers);
  },
  // 新增兌禮訂單
  writeOffRedeemItem(body, headers) {
    return ajaxService.post('/sct/put/api/v1/redeem/order-Item-writtenoff', body, headers);
  },
  // 新增訂單退貨申請
  createReturnRequest(body, headers) {
    return ajaxService.post('/sct/post/api/v2/order/return-request', body, headers);
  },
  // 取得退貨申請列表
  getReturnRequests(body) {
    return ajaxService.post('/sct/post/api/v1/member/orders/return-request', body, {});
  },
  // 取得商店主檔列表
  getStores(param) {
    const queryString = new URLSearchParams(param).toString();
    return ajaxService.post(`/sct/get/api/v1/store?${queryString}`);
  },
  // 新增兌禮訂單V2
  writeOffRedeemItemV2(body, headers) {
    return ajaxService.post('/sct/put/api/v2/redeem/order-Item-writtenoff', body, headers);
  },
  // 兌禮訂單轉贈
  postRedeemOrderItemTranfer(body) {
    return ajaxService.post('/sct/post/api/v1/redeem/order-Item-transfer', body);
  },
};
